'use strict';/* global define:false, console:false */define('modules/ahoy/directives/ahoy/controller',[],function(){'use strict';function controller($scope,Ahoy){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.status=0;ctrl.prevStep=prevStep;ctrl.nextStep=nextStep;// ctrl.canGoBack = canGoBack;
function prevStep(){return step(true);}function nextStep(){return step();}function step(back){return $scope.$broadcast('ahoy.step',!!back);}// function canGoBack() {
//   return ctrl.status;
//   // return $scope.status && $scope.status !== -1;
// }
}controller.$inject=['$scope','Ahoy'];return controller;});
